module.exports = __webpack_public_path__ + "img/partner-5.17708c8f.svg";